import { render, staticRenderFns } from "./NumberFourSVG.vue?vue&type=template&id=22386d02&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22386d02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22386d02')) {
      api.createRecord('22386d02', component.options)
    } else {
      api.reload('22386d02', component.options)
    }
    module.hot.accept("./NumberFourSVG.vue?vue&type=template&id=22386d02&scoped=true&", function () {
      api.rerender('22386d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/NumberFourSVG.vue"
export default component.exports